<template>
    <div class="contactBackground">
        <div class="container-c">
            <div><img src="/img/logo-croustillance-blanc.svg" width="340px;">
                <br/><br/> 10 rue de l'Estrey<br/>88440 Nomexy<br>
                <v-icon color="white" size="25" style="margin-top:-5px;">mdi-phone</v-icon>
                <a href="tel:0684264563"><span class="whitetext"> 06 84 26 45 63</span></a>
                <div class="Formulaire">
                    <v-icon color="white" size="25" style="margin-top:-5px;">mdi-email</v-icon>
                    <span class="whitetext"> Formulaire de contact</span><br>
                    <p>Nous avons préparé quelques questions très simples, pour vous proposer les formules les plus
                        adaptées à votre demande.
                        <br>
                        Dites-nous ce que vous savez déjà… et nous vous recontacterons pour tout le reste !</p>
                    <v-form ref="contactForm" v-model="contactFormData">
                        <v-container>
                            <v-row>
                                <v-col
                                        cols="12"
                                        md="6"
                                >
                                    <v-text-field
                                            v-model="nom"
                                            :rules="nomRules"
                                            label="Nom"
                                            required
                                    ></v-text-field>
                                </v-col>

                                <v-col
                                        cols="12"
                                        md="6"
                                >
                                    <v-text-field
                                            v-model="prenom"
                                            :rules="prenomRules"
                                            label="Prénom"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>


                                <v-col
                                        cols="12"
                                        md="6"
                                >
                                    <v-text-field
                                            v-model="email"
                                            :rules="emailRules"
                                            label="Email"
                                            required
                                    ></v-text-field>
                                </v-col>

                                <v-col
                                        cols="12"
                                        md="6"
                                >
                                    <v-text-field
                                            v-model="telephone"
                                            :rules="telephoneRules"
                                            label="Téléphone"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                            v-model="occasion"
                                            label="De quelle occasion s’agit-il ?"
                                            auto-grow
                                            outlined
                                            rows="1"
                                            row-height="15"
                                    >
                                    </v-textarea>
                                    <p class="helpForm">(Exemple : mariage, séminaire d’entreprise, dîner entre amis,
                                        départ en retraite…)</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                            v-model="type"
                                            label="Savez-vous déjà quel type de repas vous souhaitez ?"
                                            auto-grow
                                            outlined
                                            rows="1"
                                            row-height="15"
                                    >
                                    </v-textarea>
                                    <p class="helpForm">(Exemple : cocktail, buffet chaud ou froid, repas assis,
                                        animation culinaire…)</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                            v-model="besoins"
                                            label="Pensez-vous avoir besoin de serveurs ? De matériel ? De tables ? De chaises ?"
                                            auto-grow
                                            outlined
                                            rows="1"
                                            row-height="15"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                            v-model="boissons"
                                            label="Voulez-vous qu’on s’occupe des boissons ?"
                                            auto-grow
                                            outlined
                                            rows="1"
                                            row-height="15"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                            v-model="nombreInvites"
                                            label="Avez-vous une idée du nombre d’invités ?"
                                            auto-grow
                                            outlined
                                            rows="1"
                                            row-height="15"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                            v-model="dateEvenement"
                                            label="Pour finir, merci de nous préciser le lieu, la date et même l’heure de l’événement, si vous les connaissez déjà."
                                            auto-grow
                                            outlined
                                            rows="1"
                                            row-height="15"
                                    >
                                    </v-textarea>
                                    <div style="text-align:center">
                                        <v-btn x-large color="#2c6730" dark :disabled="!contactFormData"
                                               @click="sendMessage">Envoyer ma demande
                                            <v-icon right dark>mdi-send</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </div>
            </div>
        </div>
        <v-dialog
                v-model="merciWindow"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">Message envoyé !</v-card-title>

                <v-card-text>
                    Nous vous recontacterons dans les plus brefs délais. A bientôt !
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="merciWindow = false"
                    >
                        FERMER
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "contact",
        data: () => ({
            merciWindow: false,
            contactFormData: false,
            nom: '',
            prenom: '',
            nomRules: [
                v => !!v || 'Votre nom est requis'
            ],
            prenomRules: [
                v => !!v || 'Votre prénom est requis'
            ],
            email: '',
            emailRules: [
                v => !!v || 'Votre email est requis',
                v => /.+@.+/.test(v) || 'le mail ne semble pas valide',
            ],
            telephone: '',
            telephoneRules: [
                v => !!v || 'Votre téléphone est requis'
            ],
            occasion: '',
            type: '',
            besoins: '',
            boissons: '',
            nombreInvites: '',
            dateEvenement: ''
        })
        ,
        created() {
            document.getElementsByTagName('meta')["description"].content = "Prenez contact avec nous pour obtenir rapidement un devis pour vos événements. Toute l'équipe du traiteur Croustillance est à votre service de Charmes à Épinal";
            document.title = "Croustillance, votre traiteur à Épinal et ses environs";
        },
        methods: {
            sendMessage() {
                this.axios.post('/services/axiosMailer.php', {
                    name: this.nom,
                    prenom: this.prenom,
                    email: this.email,
                    telephone: this.telephone,
                    occasion: this.occasion,
                    type: this.type,
                    besoins: this.besoins,
                    boissons: this.boissons,
                    nombreInvites: this.nombreInvites,
                    dateEvenement: this.dateEvenement
                });
                this.merciWindow = true;
                this.$refs.contactForm.reset();
                this.nom = "";
                this.prenom = "";
                this.email = '';
                this.telephone = '';
                this.occasion = '';
                this.type = '';
                this.besoins = '';
                this.boissons = '';
                this.nombreInvites = '';
                this.dateEvenement = '';

            }
        }
    }
</script>

<style>
    .contactBackground {
        width: 100%;
        height: 100%;
        background: #95c01e;
    }

    .container-c {

        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Nunito', sans-serif;
        color: white;
        font-size: 30px;
        font-weight: bold;
        padding-top: 20px;
    }

    .whitetext {
        color: white;
    }

    .Formulaire {
        text-align: left;
        padding: 20px;
        background-color: #ffffff24;
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .helpForm {
        margin: 0px;
        padding: 0px;
        font-size: 14px;
        margin-top: -25px;
        color: white;
        margin-bottom: 0px !important;
    }
</style>